import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

export const initialValues = {
  vignetteRangeInfo: {
    rangeCode: '',
    rangeYear: '',
    rangeFrom: '',
    rangeTo: '',
    rangeStatus: 'ACTIVE',
  },
};

export const drawerSections: IDynamicFormWidgetSection[] = [
  {
    inputs: {
      rangeYear: {
        name: 'rangeYear',
        title: 'Vignette Range Year',
        type: FormFieldType.number,
        placeholder: 'Vignette Range Year',
        value: initialValues.vignetteRangeInfo.rangeYear,
        required: true,
        customValidator: (values) => {
          if (values.rangeYear < 1900 || values.rangeYear > 2100) {
            return 'Range Year must be between 1900 and 2100';
          }
          return '';
        },
      },
      rangeCode: {
        name: 'rangeCode',
        title: 'Vignette Range Code',
        type: FormFieldType.text,
        placeholder: 'Vignette Range Code',
        value: initialValues.vignetteRangeInfo.rangeCode,
        required: true,
      },
      rangeFrom: {
        name: 'rangeFrom',
        title: 'Vignette Range From',
        type: FormFieldType.number,
        placeholder: 'Vignette Range From',
        value: initialValues.vignetteRangeInfo.rangeFrom,
        required: true,
      },
      rangeTo: {
        name: 'rangeTo',
        title: 'Vignette Range To',
        type: FormFieldType.number,
        placeholder: 'Vignette Range To',
        value: initialValues.vignetteRangeInfo.rangeTo,
        required: true,
      },
      rangeStatus: {
        name: 'rangeStatus',
        title: 'Vignette Range Status',
        type: FormFieldType.select,
        placeholder: 'Vignette Range Status',
        value: !isEmpty(initialValues.vignetteRangeInfo.rangeStatus)
          ? initialValues.vignetteRangeInfo.rangeStatus
          : [],
        required: true,
        selectOptions: {},
      },
    },
  },
];
